export default {
    setFirstName: (state, firstName) => state.firstName = firstName,
    setLastName: (state, lastName) => state.lastName = lastName,
    setEmail: (state, email) => state.email = email,
    setAdditionalEmail: (state, additionalEmail) => state.additionalEmail = additionalEmail,
    setPhone: (state, phone) => state.phone = phone,
    setAddress1: (state, address1) => state.address1 = address1,
    setAddress2: (state, address2) => state.address2 = address2,
    setCity: (state, city) => state.city = city,
    setState: (state, payload) => state.state = payload,
    setZip: (state, zip) => state.zip = zip,
    setCountry: (state, country) => state.country = country,
    setVatId: (state, vatId) => state.vatId = vatId,
    setShippingMethod: (state, shippingMethod) => state.shippingMethod = shippingMethod,
    setShipping: (state, payload) => {
        for (let prop in state) {
            state[prop] = payload[prop] || "";
        }
    }
}